import { Component, OnInit, Output, EventEmitter, Input, SimpleChanges } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SearchResponseIO } from 'src/app/models/search-responseIO';
import { BaseSearchComponent } from 'src/app/system-common/base-search/base-search.component';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { AgentService } from '../services/agent.service';
declare const showSpinner: any;

@Component({
  selector: 'sym-agent-audit-search',
  templateUrl: './agent-audit-search.component.html',
  styleUrls: ['./agent-audit-search.component.scss'],
})
export class AgentAuditSearchComponent extends BaseSearchComponent<AgentService> implements OnInit {
  @Input() Id;
  @Input() isCriteriaNull;
  public searchName;
  public searchCriteriaData;
  // id: any;
  isSearchFilteredByCriteria: boolean;
  constructor(
    public service: AgentService,
    public headerService: HeaderService,
    public router: Router,
    public route: ActivatedRoute,
    public settingService: SettingService
  ) {
    super(service, router, headerService);
    // if (this.Id == undefined || this.Id == 0) {
    //   this.Id = this.route.snapshot.paramMap.get('id');
    // this.id = this.service.id;
    // }
    this.isSearchFilteredByCriteria = true;
    this.service.forAuditSearchList = false;
    this.searchName = 'SearchAuditResult';
  }

  ngOnInit() {
    if (this.service.isAuditButtonClicked)
      this.searchCriteriaData = {
        'PortalSearchAuditDO.id': this.Id,
      };
    else {
      this.searchCriteriaData = {
        'PortalSearchAuditDO.id': null,
      };
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log('changes', changes);

    if (changes['isAuditButtonClicked'] && changes['isAuditButtonClicked'].currentValue) {
      //   if (this.displayAuditPopUp) {
      //     this.searchAuditResult();
      //   }
    }
  }

  // searchAuditResult() {
  //   setTimeout(() => {
  //     showSpinner();
  //   }, 5);
  //   this.service.forAuditSearchList = true;
  //   this.service.find(false, undefined).subscribe(
  //     (criteriaData) => {
  //       this.searchCriteriaData = {
  //         'PortalSearchAuditDO.id': this.Id,
  //       };
  //       // criteriaData['data']['searchCriteriaData']['PortalSearchAuditDO.id'] = '' + this.id;
  //       this.settingService.setSessionStorageValue(
  //         'AuditChanges',
  //         JSON.stringify(criteriaData['data']['searchCriteriaData'])
  //       );
  //       if (this.settingService.getSessionStorageValue('AuditChanges')) {
  //         this.isSearchFilteredByCriteria = false;
  //       }
  //       // this.service.isAuditButtonClicked = false;
  //       // setTimeout(() => {
  //       //   // this.find(true, criteriaData['data']['searchCriteriaData']);
  //       //   this.openModal('agentAuditPopUp');
  //       // }, 2000);
  //     },
  //     (error) => {
  //       console.log('Criteria load failed', error);
  //     }
  //   );
  // }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    // this.displayAuditPopUp = true;
    // console.log('isAuditSearchDisplayed', this.isAuditSearchDisplayed);
    this.service.isAuditButtonClicked = true;
    this.Id = null;
    console.log('this.Id', this.Id);
    // this.searchCriteriaData = {
    //   'PortalSearchAuditDO.id': null,
    // };
  }
}
